var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaperclip2 = function SvgPaperclip2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4383 11.5099L12.2483 20.6999C11.1225 21.8257 9.59552 22.4582 8.00334 22.4582C6.41115 22.4582 4.88418 21.8257 3.75834 20.6999C2.63249 19.574 2 18.0471 2 16.4549C2 14.8627 2.63249 13.3357 3.75834 12.2099L12.9483 3.01988C13.6989 2.26932 14.7169 1.84766 15.7783 1.84766C16.8398 1.84766 17.8578 2.26932 18.6083 3.01988C19.3589 3.77044 19.7806 4.78842 19.7806 5.84988C19.7806 6.91134 19.3589 7.92932 18.6083 8.67988L9.40834 17.8699C9.03306 18.2452 8.52407 18.456 7.99334 18.456C7.46261 18.456 6.95362 18.2452 6.57834 17.8699C6.20306 17.4946 5.99222 16.9856 5.99222 16.4549C5.99222 15.9242 6.20306 15.4152 6.57834 15.0399L15.0683 6.55988",
    stroke: "#8A8A8A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperclip2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paperclip2.81e6c168.svg";
export { ForwardRef as ReactComponent };